import React from 'react';
import PublicIcon from '@material-ui/icons/Public';
import { CustomBreadcrumbs, CustomList } from 'candy-commons-components';
import { TextField, useTranslate, BooleanField } from 'react-admin';
import DynamoPagination from '../../components/DynamoPagination';
import CustomDatagrid from '../../components/organisms/customDatagrid';

const EcommerceCountryConfigList = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation(
                'resources.ecommerce-country-config.name',
                'Ecommerce Country Configuration'
            ),
            url: '',
            icon: <PublicIcon />,
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <CustomList
                exporter={false}
                perPage={25}
                {...props}
                pagination={
                    <DynamoPagination resource="ecommerce-country-config" />
                }
                bulkActionButtons={false}
            >
                <CustomDatagrid selectable rowClick="edit" choiceColumns>
                    <TextField source="brand" label="Brand" />
                    <TextField source="country" label="Country" />
                    <BooleanField source="enabled" label="Enabled" />
                </CustomDatagrid>
            </CustomList>
        </>
    );
};

export default EcommerceCountryConfigList;
